import { takeLatest, call, put } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi, handleLogout } from '../utils/api';
import { setLoader } from '../actions/loaderAction';
function* logout(action) {
  try {
    yield call(callApi, URLS.LOGOUT, 'POST', {});
    yield put(setLoader(false));
    // eslint-disable-next-line no-prototype-builtins
    if (window.hasOwnProperty('Intercom')) {
      window.Intercom('shutdown');
    }
    handleLogout();
    if (window.localStorage.getItem('hasLogin')) {
      window.localStorage.removeItem('hasLogin');
    }
  } catch (e) {
    yield put(setLoader(false));
    handleLogout();
    if (window.localStorage.getItem('hasLogin')) {
      window.localStorage.removeItem('hasLogin');
    }
  }
}

export function* HeaderWatcherSaga() {
  yield takeLatest('LOGOUT', logout);
}
